<template>
  <div class="bg-theme-light py-20 ">
    <div class="section container mx-auto flex flex-col items-center w-10/12">
      <h1 class="text-4xl md:text-5xl mb-14 mx-auto font-bold text-center text-gray-800">{{links.title}}</h1>
      <div class="md:flex">
        <div class="md:w-1/2 md:px-2">
          <router-link class="w-full" to="/catalogos-digitales">
            <div class="w-12/12 px-7 py-10 border bg-white border-gray-200 rounded-2xl shadow hover:shadow-xl  cursor-pointer text-center bg-theme-sky text-white">
              <div class="">Bibliotecas Nacionales</div>
            </div>
          </router-link>   
          <div class="grid grid-cols-2 gap-2 mt-2">
              <router-link class="col-span-1 flex" to="/catalogos-digitales">
                <div class="flex-1 flex items-center  justify-center px-7 py-10 border bg-white border-gray-200 rounded-2xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer">
                  <div class="">Recursos</div> 
                </div>
              </router-link>
                <router-link class="col-span-1 flex" to="/catalogos-digitales">
                  <div class="flex-1 flex items-center  justify-center px-7 py-10 border bg-white border-gray-200 rounded-2xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer text-center">
                    <div class="">Bibliotecas Públicas</div>
                  </div>
                </router-link>
            </div>     
            <div class="grid grid-cols-2 gap-2 mt-2">        

                <router-link class="col-span-1 flex" to="/catalogos-digitales">
                  <div class="flex-1 flex items-center  justify-center px-7 py-10 border bg-white border-gray-200 rounded-2xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer">
                    <div class="">Investigación</div>
                  </div>
                </router-link>                             
                
                <router-link class="col-span-1 flex" to="/catalogos-digitales">
                  <div class="flex-1 flex items-center  justify-center px-7 py-10 border bg-white border-gray-200 rounded-2xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer text-center">
                    <div class="">Recursos para bibliotecarios</div>
                  </div>
                </router-link>                            
            
            </div>  

        </div>
        <div class="hidden md:w-1/2 md:px-2 md:block">
          <img class="rounded-xl shadow-2xl" :src="imageUrl" alt="">
        </div>  

      </div>

    </div>
  </div>

</template>

<script>
    export default {
        
        props: {
            'links':Object
        },
        data(){
            return {
                imageUrl: "",
            }
        },

        watch:{
            links:function(){
              //  this.imageUrl = 'http://192.168.0.11:8005/' + this.$props.links.image
              this.imageUrl = `${process.env.VUE_APP_URL_CULTURAPP}${this.$props.links.image}`               
            }
        }
    }

</script>
  

  